export function locate(el, attr = "data-id") {
    let node = !el.tagName && el.target ? el.target : el;
    while (node) {
        if (node.getAttribute) {
            const id = node.getAttribute(attr);
            if (id)
                return node;
        }
        node = node.parentNode;
    }
    return null;
}
export function locateByValue(el, value, attr = "data-id") {
    let node = !el.tagName && el.target ? el.target : el;
    while (node) {
        if (node.getAttribute) {
            const attrValue = node.getAttribute(attr);
            if (attrValue === value)
                return node;
        }
        node = node.parentNode;
    }
    return null;
}
export function locateAttr(el, attr = "data-id") {
    const node = locate(el, attr);
    if (node)
        return node.getAttribute(attr);
    return null;
}
export function locateID(el, attr = "data-id") {
    const node = locate(el, attr);
    if (node) {
        return id(node.getAttribute(attr));
    }
    return null;
}
export function locateNode(el, node) {
    let n = el;
    while (n) {
        if (n === node) {
            return true;
        }
        n = n?.parentNode;
    }
    return null;
}
export function id(value) {
    if (typeof value === "string") {
        const t = value * 1;
        if (!isNaN(t))
            return t;
    }
    return value;
}
//# sourceMappingURL=locate.js.map